import { serviceName } from '../resources/serviceConstants';
import {
  SKILL_MAP,
  SKILL_MAP_FILTER,
  DELETE_SKILL_MAP,
} from '../resources/endPoint';

export const getMappedSkills = (userId) => {
  // API call to fetch mapped skills
  const url = userId ? `${SKILL_MAP}/?userId=${userId}` : SKILL_MAP;

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.SKILLS_MS,
  };
};

export const getFilteredSkills = (filterData) => {
  // API call to fetch filtered skills

  return {
    url: SKILL_MAP_FILTER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.SKILLS_MS,
    payload: filterData,
  };
};

export const updateMappedSkill = (payload) => {
  // API call to update mapped skills

  return {
    url: SKILL_MAP,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.SKILLS_MS,
    payload,
  };
};

export const addMappedSkills = (payload) => {
  // API call to add mapped skills

  return {
    url: SKILL_MAP,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.SKILLS_MS,
    payload,
  };
};

export const deleteSkillMap = (selectedSkillMap) => {
  const url = DELETE_SKILL_MAP.replace('{mapId}', selectedSkillMap);

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.SKILLS_MS,
  };
};
